import React from 'react';

import { Check } from 'react-feather';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const SubmittedUserResponse = props => {
  const { response, version, completedAt } = props;
  return (
    <div className="QuestionElement--responseTab">
      <div className="QuestionElement--submissionInfo-container">
        <div className="QuestionElement--submissionInfo-version">
          <div className="QuestionElement--submittedIcon">
            <Check size="11px" />
          </div>
          <div className="d-f fd-c">
            <Text variant={TEXT_VARIANTS.SUBHEADER}>
              {t('practice.repeatability.version')} {version}
            </Text>
            <Text variant={TEXT_VARIANTS.BODY_LIGHT}>
              {moment(response.createdAt).format('MMM DD, YYYY')}
            </Text>
          </div>
        </div>
        <div className="d-f fd-c m-fd-r QuestionElement--responseTab-submitted">
          <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD} className="mr-4">
            {t('practice.repeatability.submitted')}
          </Text>
          <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>
            {moment(completedAt).format('MMM DD, YYYY')}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default SubmittedUserResponse;
